/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useForm } from 'react-hook-form';

import { Button, CardContent, FormControl, Modal, TextField, Chip } from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MainCard from 'components/MainCard';
import { BootstrapInput, fileChangedHandler } from 'data/data';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import { deleteMasterEquipmentPartsImagesById, getMasterEquipmentPartsImagesById, getMasterEquipmentPartsImagesByQuery } from 'components/axios/masterEquipmentPartsImageAxios';
import PageInfo from 'components/PageInfo';
import FileViewerByFileUrl from 'components/FileViewerByFileUrl';
import { customFileAxios } from 'components/axios/customAxios';

const EquipmentPartImageLayer = ({partInfo=null, str, partSetValue, isPartImageMapping, setIsPartImageMapping, idx}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);setIsForm(false);};
    const handleClose = () => setOpen(false);

    const [id, setId] = useState(null);
    const [fileLoading, setFileLoading] = useState(false);
    const [isForm, setIsForm] = useState(false);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

    const [masterEquipmentParts, setMasterEquipmentParts] = useState(null);
    const [masterEquipmentPart, setMasterEquipmentPart] = useState(null);
    const [normalFile, setNormalFile] = useState(null);
    const [errorFile, setErrorFile] = useState(null);

    const [normalFileData, setNormalFileData] = useState(null);
    const [errorFileData, setErrorFileData] = useState(null);
    const [normalFileId, setNormalFileId] = useState(null);
    const [errorFileId, setErrorFileId] = useState(null);
    const [selectImageId , setSelectImageId] = useState(partInfo?.image?.id || null);

    const { control, register, handleSubmit, setValue, formState : {isDirty, errors } } = useForm({});

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      // setIsLoading(false);
    }

    useEffect(()=>{
      // console.log(open, isForm, id)
      if (open) {
        if (!isForm) {
          // setIsForm(false);
          masterEquipmentPartImagesList();
        } else {
          if (id !== null) {  // 상세
            getMasterEquipmentPartsImagesById(id).then((data)=>{
              // console.log(data)
              if (data) {
                setMasterEquipmentPart(data);
                setValue('name', data.equipmentPartName);
                const normalFile = data.imageFiles.find(file=>file.code === '255');
                const errorFile = data.imageFiles.find(file=>file.code === '0');
                setNormalFileData(normalFile);
                setNormalFileId(normalFile?.id || null);
                setErrorFileData(errorFile);
                setErrorFileId(errorFile?.id || null);
              } else {
                setMasterEquipmentPart(null);
                setValue('name', null);
                setNormalFileData(null);
                setNormalFileId(null);
                setErrorFileData(null);
                setErrorFileId(null);
              }
            })
          } else {
            setMasterEquipmentPart(null);
            setValue('name', null);
            setNormalFileData(null);
            setNormalFileId(null);
            setErrorFileData(null);
            setErrorFileId(null);
          }
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[open, isForm, id]);

    // 마스터 자재 이미지 목록
    const masterEquipmentPartImagesList = async (curPage=currentPage) => {
      isNaN(curPage) && setCurrentPage(0);
      isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

      let param = {
        page : curPage,
        size : pageSize,
      };

      let keyword = searchKeyword;
      if (searchKeyword) {
          keyword = 'contains('+searchKeyword+')';
          param.equipmentPartName = keyword;
      }

      Promise.all([
        await getMasterEquipmentPartsImagesByQuery(param).then((data)=>{
          // console.log(data)
          if (data != null) {
            if(data.page) {
              setPageInfo(data.page);
            } else {
              setCurrentPage(0);
              pageInfo = {
                size : pageInfo.size,
                totalElements : 0,
                totalPages : 0,
                number : 0
              }
              setPageInfo(pageInfo);
            }
            if(data._embedded) {
              setMasterEquipmentParts(data._embedded.images);
              // return data.page.totalElements;
            } else {
              setMasterEquipmentParts([]);
            }
          }
        })
      ]).then((res)=>{
        
      })
    };

    // 마스터 자재 이미지 등록/수정
    const onSubmit = (data, e) => {
      e.preventDefault();
      setFileLoading(true);

      const equipmentPartImageId = data.id;
      const equipmentPartName = data.name;

      let dto = {
          // id: equipmentPartImageId,
          equipmentPartName
      };

      let formData = new FormData();
      formData.append("normalFile", normalFile);
      formData.append("errorFile", errorFile);

      try {
          if (equipmentPartImageId) {  // 수정
              dto.id = equipmentPartImageId;
              dto.imageFiles = [];
              if (!normalFile && (normalFileId && normalFileId !== 0)) {
                  dto.imageFiles.push({code : '255'});
              }
              if (!errorFile  && (errorFileId && errorFileId !== 0)) {
                dto.imageFiles.push({code : '0'});
              }
              
              // console.log("============ dto =============");
              // console.log(dto);
              formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
              // console.log("============ formData =============");
              // for (var value of formData.entries()) {
              //     console.log(value[0]+', ',value[1]);
              // }
              
              openModal(modals.confirmModal, {
                  onSubmit : (value) => {
                    try {
                        const res = customFileAxios.patch(`/api/masterEquipmentParts/images/${equipmentPartImageId}`, formData).then((res)=>{
                            setFileLoading(false);
                            alertMessage = t('message.common.alert.modify.done');
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                            setIsForm(false);
                        }).catch((err)=>{
                            console.log(err);
                            setFileLoading(false);
                            if (!err.response?.data?.message) {
                                alertMessage = err.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            } else if (err.response.data.message) {
                                alertMessage = err.response.data.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            }
                        });
                        // return res.data;
                    } catch (error) {
                        console.error("error :", error);
                        throw error;
                    }
                    
                    // axios({
                    //       method: "patch",
                    //       url: process.env.REACT_APP_API_URL+"/api/masterEquipmentParts/images/"+equipmentPartImageId,
                    //       data: formData,
                    //       headers : {
                    //           'Content-type' : 'multipart/form-data',
                    //           accept : 'application/json,',
                    //           'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
                    //           'Accept-Language' : t('locale')
                    //       }
                    //   }).then((res)=>{
                    //       setFileLoading(false);
                    //       // parentSetIsLoading(false);
                    //       alertMessage = t('message.common.alert.modify.done');
                    //       setAlertMessage(alertMessage);
                    //       handleAlertClick();
                    //       setIsForm(false);
                    //   }).catch((err)=>{
                    //       console.log(err);
                    //       setFileLoading(false);
                    //       if (!err.response?.data?.message) {
                    //           alertMessage = err.message;
                    //           setAlertMessage(alertMessage);
                    //           handleAlertClick();
                    //       } else if (err.response.data.message) {
                    //           alertMessage = err.response.data.message;
                    //           setAlertMessage(alertMessage);
                    //           handleAlertClick();
                    //       }
                    //   });
                  },
                  onClose : () => {
                      setFileLoading(false);
                      // console.log('close');
                  },
                  message: t('message.common.alert.modify.question'),
              });
          } else {    // 등록
              // console.log("============ dto =============");
              // console.log(dto);
              formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
              // console.log("============ formData =============");
              // for (var value of formData.entries()) {
              //     console.log(value[0]+', ',value[1]);
              // }

              openModal(modals.confirmModal, {
                  onSubmit : (value) => {
                    try {
                        const res = customFileAxios.post(`/api/masterEquipmentParts/images`, formData).then((res)=>{
                            setFileLoading(false);
                            alertMessage = t('message.common.alert.write.done');
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                            setIsForm(false);
                        }).catch((err)=>{
                            console.log(err);
                            setFileLoading(false);
                            if (!err.response?.data?.message) {
                                alertMessage = err.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            } else if (err.response.data.message) {
                                alertMessage = err.response.data.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            }
                        });
                        // return res.data;
                    } catch (error) {
                        console.error("error :", error);
                        throw error;
                    }

                    // axios({
                    //       method: "post",
                    //       url: process.env.REACT_APP_API_URL+"/api/masterEquipmentParts/images",
                    //       data: formData,
                    //       headers : {
                    //           'Content-type' : 'multipart/form-data',
                    //           accept : 'application/json,',
                    //           'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
                    //           'Accept-Language' : t('locale')
                    //       }
                    //   }).then((res)=>{
                    //       setFileLoading(false);
                    //       // parentSetIsLoading(false);
                    //       //console.log(res);
                    //       alertMessage = t('message.common.alert.write.done');
                    //       setAlertMessage(alertMessage);
                    //       handleAlertClick();
                    //       setIsForm(false);
                    //       // navigate('../modify/'+res.data.id+window.location.search);
                    //   }).catch((err)=>{
                    //       console.log(err);
                    //       setFileLoading(false);
                    //       if (!err.response?.data?.message) {
                    //           alertMessage = err.message;
                    //           setAlertMessage(alertMessage);
                    //           handleAlertClick();
                    //       } else if (err.response.data.message) {
                    //           alertMessage = err.response.data.message;
                    //           setAlertMessage(alertMessage);
                    //           handleAlertClick();
                    //       }
                    //   });
                  },
                  onClose : () => {
                      setFileLoading(false);
                      // console.log('close');
                  },
                  message: t('message.common.alert.write.question'),
              });
          }
      } catch(error) {
          console.log(error);
          setFileLoading(false);
      }
    }

    const handleDeleteBtnClick = (param) => {
      if (param) {
          openModal(modals.confirmModal, {
          onSubmit : (value) => {
            deleteMasterEquipmentPartsImagesById(param).then((res) => {
              setId(null);
              setIsForm(false);
              alertMessage = t('message.common.alert.delete');
              setAlertMessage(alertMessage);
              handleAlertClick();
              masterEquipmentPartImagesList(0);
            }).catch((err)=>{
                console.log(err);
                if (!err.response?.data?.message) {
                    alertMessage = err.message;
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                } else if (err.response.data.message) {
                    alertMessage = err.response.data.message;
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                }
            });
          },
          onClose : () => {
              // console.log('close');
          },
          message: t('message.common.alert.delete.question'),
          });
      }
    }

    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };

    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      // console.log('search')
      masterEquipmentPartImagesList();
    };

    // 선택
    const handleSelect = (id) => {
      partSetValue(str, id);
      if (isPartImageMapping) {
        let changMappings = [...isPartImageMapping];
        changMappings[idx] = 'O';
        setIsPartImageMapping(changMappings);
      }
      setOpen(false);
    }

    // 선택해제
    const handleSelectCancel = () => {
      partSetValue(str,null);
      setSelectImageId(null)
      if (isPartImageMapping) {
        let changMappings = [...isPartImageMapping];
        changMappings[idx] = 'X';
        setIsPartImageMapping(changMappings);
      }
      setOpen(false);
      // alertMessage = t();
      // setAlertMessage(alertMessage);
      // handleAlertClick();
    }

    if (!isForm) {  // 목록
      return (
        <>
          <Button variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset"}}>
            {t('message.common.subtitle.equipmentPart.image')}
          </Button>
  
          <Modal className="pop_box pop_box4" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            {/* 모달1 (목록) */}
            <MainCard modal darkTitle content={false} style={{padding:"10px", minWidth : "800px", minHeight : "300px"}}>
              <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <div>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                  <Chip label={`${t('message.common.title.equipmentPart.image')}`} color="primary" style={{maxWidth:"400px"}}/>
                </div>

                <div>
                  <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                    {t('message.common.btn.close')}
                  </Button>
                </div>
              </div>
  
              <CardContent className='modal_imagelayer'>
                {selectImageId &&
                <div className='tit'>
                  <Button className='orange_btn' style={{marginLeft:"7px" ,padding:"3px 15px"}} onClick={()=>{handleSelectCancel()}}>
                    {t('message.common.btn.select.cancel')}
                  </Button>
                </div>
                }
                <div className='modal_imagelayer_search' style={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}>
                  <FormControl sx={{ m: 1 }} variant="standard">
                    <BootstrapInput id="demo-customized-textbox" className='pop_image_tit' value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress} />
                  </FormControl>
  
                  <Button variant="contained" style={{marginLeft:"5px", padding:"4px 15px"}} onClick={handleSearch}>
                    <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                  </Button>
                </div>
  
                {masterEquipmentParts && masterEquipmentParts.map((part, idx)=>{
                  // console.log(part)
                  const normalFile = part.imageFiles.find(file=>file.code === '255');
                  const errorFile = part.imageFiles.find(file=>file.code === '0');
                  let className = '';
                  if (part.id === selectImageId) {
                    className = 'modal_imagelayer_select_box';
                  }
                  return (
                <div key={idx} className={className}>
                  <div className='modal_imagelayer_select'>
                    <div>
                      <span>{part.equipmentPartName}</span>&nbsp;&nbsp;
                      <Button variant="contained" className="small_btn" onClick={()=>{handleSelect(part.id)}}>{t('message.common.subtitle.select')}</Button>
                    </div>
    
                    <div>
                      <Button variant="contained" className="small_btn" onClick={()=>{setId(part.id);setIsForm(true);setValue('id', part.id)}}>{t('message.common.btn.modify')}</Button>&nbsp;
                      <Button variant="contained" color='error' className="small_btn" onClick={()=>{handleDeleteBtnClick(part.id)}}>{t('message.common.btn.delete')}</Button>
                    </div>
                  </div>

                  <div className='modal_imagelayer_img'>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"center",color:"#000", width:"160px"}}>
                    {normalFile ? 
                      // <img src={`${process.env.REACT_APP_API_URL}/api/download/${normalFile.file.id}`} alt='' />
                      <FileViewerByFileUrl fileUrl={`${process.env.REACT_APP_API_URL}/api/download/${normalFile.file.id}`} extension={normalFile.file.contentType.split('/')[1]} muted={true} />
                      :
                      <div style={{margin: "4px", width: "152px", height: "105px", border: "1px solid #d3d3d3"}}></div>
                    }
                    {t('message.common.normal')}
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"center",color:"#000", width:"160px"}}>
                    {errorFile ? 
                      // <img src={`${process.env.REACT_APP_API_URL}/api/download/${errorFile.file.id}`} alt='' />
                      <FileViewerByFileUrl fileUrl={`${process.env.REACT_APP_API_URL}/api/download/${errorFile.file.id}`} extension={errorFile.file.contentType.split('/')[1]} muted={true} />
                      :
                      <div style={{margin: "4px", width: "152px", height: "105px", border: "1px solid #d3d3d3"}}></div>
                    }
                      {t('message.common.title.defect')}
                    </div>
                  </div>
                </div>
                  )
                })}
                <div style={{textAlign:"right"}}>
                  <Button variant="contained" style={{padding:"3px 15px"}} onClick={()=>{setIsForm(!isForm); setId(null); setValue('id', '')}}>
                    {t('message.common.btn.create')}
                  </Button>
                </div>

                <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>

              </CardContent>
            </MainCard>
          </Modal>
        </>
      )
    } else {  // 등록, 수정폼
      return (
        <>
          <Button variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset"}} color="secondary">
            {t('message.common.subtitle.equipmentPart.image')}
          </Button>
  
          <Modal className="pop_box pop_box4" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            {/* 모달2 (등록/수정) */}
            <MainCard title={t('message.common.title.equipmentPart.image')} modal darkTitle content={false} style={{padding:"10px"}}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div style={{marginTop:"-40px",textAlign:"right"}}>
                  <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                    {t('message.common.btn.close')}
                  </Button>
                </div>

                <CardContent className='modal_imagelayer' style={{marginTop:"20px"}}>
                  {masterEquipmentPart && <input type="hidden" {...register("id")} value={masterEquipmentPart?.id || ''} />}
                  <div style={{border: "1px solid #505150"}}>
                    <div className='modal_imagelayer_select modal_imagelayer_input'>
                      <span>{t('message.common.subtitle.meterial.name')} :</span>
                      <FormControl sx={{ m: 1 }} variant="standard">
                        <TextField className='pop_image_tit' id="outlined-basic" 
                          // key={'equipmentPartName'}
                          aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                          // defaultValue={masterEquipmentPart?.equipmentPartName || '11'}
                          {...register("name", {
                              required : t('message.common.error.text.material.input')
                          })} 
                          sx={{ minWidth: '60%' , backgroundColor: "#fff"}} />
                        {errors.name && <small role="alert">&nbsp;&nbsp;{errors.name.message}</small>}
                      </FormControl>
                    </div>
                  </div>

                  <div className='modal_imagelayer_img modal_imagelayer_img1'>
                    <div>
                      <span>{t('message.common.normal')}</span>
                      <div style={{display:"flex", padding: "10px"}}>
                          <div>
                              <input
                                  type="file" 
                                  accept=".jpg,.jpeg,.png,.gif,.mp4" 
                                  onChange={(e)=>{
                                    setNormalFile(e.target.files[0]);
                                    // fileChangedHandler(e, 190, 127, setNormalFile, alertMessage, setAlertMessage, handleAlertClick);
                                    setNormalFileId(null);
                                  }}
                              />
                              {normalFileId && 
                                  <>
                                      <img src={`${process.env.REACT_APP_API_URL}/api/download/${normalFileData.file.id}`} alt='' />
                                      <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => {setNormalFileId(null);setNormalFile(null);}}>-</RemoveCircleOutlineIcon>
                                  </>
                              }
                          </div>
                      </div>
                    </div>
                    <div>
                      <span>{t('message.common.title.defect')}</span>
                      <div style={{display:"flex", padding: "10px"}}>
                          <div>
                              <input
                                  type="file" 
                                  accept=".jpg,.jpeg,.png,.gif,.mp4" 
                                  onChange={(e)=>{
                                    setErrorFile(e.target.files[0]);
                                    // fileChangedHandler(e, 190, 127, setErrorFile, alertMessage, setAlertMessage, handleAlertClick);
                                    setErrorFileId(null);
                                  }}
                              />
                              {errorFileId && 
                                  <>
                                      <img src={`${process.env.REACT_APP_API_URL}/api/download/${errorFileData.file.id}`} alt='' />
                                      <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => {setErrorFileId(null);setErrorFile(null);}}>-</RemoveCircleOutlineIcon>
                                  </>
                              }
                          </div>
                      </div>
                    </div>
                  </div>
    
                  <div style={{"marginTop": "10px",display: "flex","justifyContent": "space-between"}}>
                    <Button variant="contained" color="info" className="small_btn" /*style={{padding:"3px 15px"}}*/ onClick={()=>{setIsForm(!isForm); setId(null)}}>
                      {t('message.common.btn.prev')}
                    </Button>
                  
                    {masterEquipmentPart ?
                    <div style={{marginTop:"5px"}}>
                      <LoadingButton variant="contained" color="success" className="small_btn" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</LoadingButton>
                      &nbsp;<Button variant="contained" color="error" className="small_btn" onClick={()=>{handleDeleteBtnClick(masterEquipmentPart.id)}}>{t('message.common.btn.delete')}</Button>
                    </div>
                    :
                    <div className="btn_right" style={{margin:"8px"}}>
                      <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.create')}</LoadingButton>
                    </div>
                    }
                  </div>
                </CardContent>
              </form>
            </MainCard>
          </Modal>
        </>
      )
  }
}

export default EquipmentPartImageLayer;